import Vue from 'vue';
import VueI18n from 'vue-i18n';
import helpers from './helpers';

Vue.use(VueI18n);

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  })
  return messages;
}

const FALLBACKS = {
  // fallback to spanish
  'ca': 'es-ES',
  'es': 'es-ES',
  'ca-ES': 'es-ES',
  'es-AR': 'es-ES',
  'es-BO': 'es-ES',
  'es-CL': 'es-ES',
  'es-CO': 'es-ES',
  'es-CR': 'es-ES',
  'es-DO': 'es-ES',
  'es-EC': 'es-ES',
  'es-GQ': 'es-ES',
  'es-GT': 'es-ES',
  'es-HN': 'es-ES',
  'es-MX': 'es-ES',
  'es-NI': 'es-ES',
  'es-PA': 'es-ES',
  'es-PE': 'es-ES',
  'es-PR': 'es-ES',
  'es-PY': 'es-ES',
  'es-SV': 'es-ES',
  'es-US': 'es-ES',
  'es-UY': 'es-ES',
  'es-VE': 'es-ES',
  'es-XL': 'es-ES',
  'eu-ES': 'es-ES',
  'gl-ES': 'es-ES',
  // fallback to english
  'en-AS': 'en-US',
  'en-AU': 'en-US',
  'en-BE': 'en-US',
  'en-BW': 'en-US',
  'en-BZ': 'en-US',
  'en-CA': 'en-US',
  'en-GB': 'en-US',
  'en-GU': 'en-US',
  'en-HK': 'en-US',
  'en-IN': 'en-US',
  'en-IE': 'en-US',
  'en-IL': 'en-US',
  'en-JM': 'en-US',
  'en-MT': 'en-US',
  'en-MH': 'en-US',
  'en-MP': 'en-US',
  'en-MU': 'en-US',
  'en-NA': 'en-US',
  'en-NZ': 'en-US',
  'en-PK': 'en-US',
  'en-PH': 'en-US',
  'en-SG': 'en-US',
  'en-TT': 'en-US',
  'en-UM': 'en-US',
  'en-VI': 'en-US',
  'en-ZA': 'en-US',
  'en-ZW': 'en-US',
}

let lang = helpers.detectLanguage();

if (lang in FALLBACKS) {
  lang = FALLBACKS[lang];
}


export default new VueI18n({
  locale: lang.toLowerCase() || process.env.VUE_APP_I18N_LOCALE || 'en-us',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-us',
  messages: loadLocaleMessages()
})
